// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2015":"62030658","3767":"93267634","3826":"d36e4cbc","4327":"93267634","4328":"93267634","5152":"b69c9285","5520":"d36e4cbc","6855":"93267634","7936":"93267634"}[chunkId] + ".chunk.css";
};